// extracted by mini-css-extract-plugin
module.exports = {"note":"ebc3b5650599fc3536cc2d832346ddce-less"};